import Bill from '@/manager/billing/models/bill.model';
import { Note } from '@/manager/convocation/note.model';


export interface State {
    list: Bill[];
    billNoteList: Note[];
    currentBill: Bill;
}

export const state: State = {
    list: [],
    billNoteList: [],
    currentBill: new Bill(),
};
